export const addToGoogleDataLayer = (
  virtualPageURL,
  virtualPageTitle,
  virtualLanguage
) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "Virtual Page View",
      virtualPageURL: virtualPageURL,
      virtualPageTitle: virtualPageTitle,
      virtualLanguage: virtualLanguage
      // ...mapServices(services, virtualLanguage)
    });
  }
};

export const mapServices = (services, language) => {
  const servicesMap = {};
  services.forEach((service, i) => {
    servicesMap[`service${i + 1}`] =
      language === "en" ? service.name : service.nameFr;
  });
  return servicesMap;
};

export const checkCookiesEnabled = () => {
  try {
    var cookieEnabled = navigator.cookieEnabled;
    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
      if (cookieEnabled) {
        return true;
      } else {
        return "select_service.enable_cookies";
      }
    }
    return cookieEnabled;
  } catch (e) {
    console.log(e);
  }
};
export const formServiceRequestBody = (services, accessibleServiceData) => {
  try {
    let requestBody = [];
    if (services && services.length > 0) {
      if (
        accessibleServiceData &&
        accessibleServiceData.serviceId &&
        accessibleServiceData.duration
      ) {
        requestBody.push(accessibleServiceData);
      }
      services.forEach((service) => {
        requestBody.push({
          serviceId: service["serviceId"],
          name: service["name"],
          duration: service["duration"]
        });
      });
    }
    return requestBody;
  } catch (e) {
    console.log(e);
  }
};

export const formReserveRequestBody = (
  branchId,
  date,
  time,
  services,
  accessibleServiceData
) => {
  try {
    let reserveBody = {};
    if (date && time && services && services.length > 0) {
      reserveBody = {
        branchId,
        timeId: time,
        dateId: date,
        serviceRequest: formServiceRequestBody(services, accessibleServiceData)
      };
    }
    return reserveBody;
  } catch (err) {
    console.log(err);
  }
};

export const formConfirmRequestBody = (
  person,
  branchId,
  date,
  time,
  services,
  accessibleServiceData,
  reservePublicId
) => {
  try {
    let confirmBody = {};
    if (person && person.firstName && person.lastName && person.emailAddress) {
      confirmBody = formReserveRequestBody(
        branchId,
        date,
        time,
        services,
        accessibleServiceData
      );
      confirmBody["person"] = person;
      confirmBody["confirmPublicId"] = reservePublicId;
    }
    return confirmBody;
  } catch (err) {
    console.log(err);
  }
};
